import React from "react";
import styled from "styled-components";
import MathText from "./MathText";
import { getHandoutWordIcon, handoutIconPreviewStyle } from "../../features/handoutWordLayout";

export default function HandoutWordHeading({ settings, role, title, number }) {
  const icon = getHandoutWordIcon(settings, role, number);
  const wave = role === "type" ? getHandoutWordIcon(settings, "wave") : null;
  return <Heading $role={role} $hasIcon={Boolean(icon)} data-word-heading={role} role="heading" aria-level={role === "chapter" ? 2 : 3}>
    {icon && <IconHolder $role={role} style={handoutIconPreviewStyle(icon)}>
      <img src={icon.url} alt="" />
      {role === "chapter" && number !== undefined && <UnitNumber>{number}</UnitNumber>}
    </IconHolder>}
    {title && <Caption $role={role} style={role === "chapter" && icon ? { marginLeft: `calc(${icon.width_cm || 4.64}cm + 0.4cm)` } : undefined}><MathText source={title} fallback="" /></Caption>}
    {wave && <Wave src={wave.url} alt="" style={handoutIconPreviewStyle(wave)} />}
  </Heading>;
}

const Heading = styled.div`
  position: relative;
  display: flex;
  align-items: ${({ $role }) => $role === "chapter" ? "flex-start" : "center"};
  gap: ${({ $role }) => $role === "focus" ? "0.38cm" : $role === "chapter" ? "0.4cm" : "0.18cm"};
  margin: 0 0 ${({ $role }) => $role === "chapter" ? "4pt" : "8pt"};
  line-height: 1;
  break-after: avoid;
  ${({ $role, $hasIcon }) => $role === "chapter" && $hasIcon && "height: 44.5pt;"}
  ${({ $role, $hasIcon }) => $role === "focus" && $hasIcon && "display: grid; grid-template-columns: 4.53cm minmax(0, 1fr); gap: 0;"}
`;
const IconHolder = styled.span`
  position: relative;
  display: inline-block;
  flex: 0 0 auto;
  z-index: 1;
  ${({ $role }) => $role === "chapter" && "position: absolute; left: 0; top: 0;"}
  img { display: block; width: 100%; height: 100%; object-fit: contain; }
`;
const UnitNumber = styled.span`
  position: absolute;
  left: 89%;
  top: 35%;
  transform: translate(-50%, -50%);
  color: #fff;
  font: 700 25pt/1 "Microsoft JhengHei UI", "微軟正黑體", "Microsoft JhengHei", "PingFang TC", sans-serif;
`;
const Caption = styled.span`
  position: relative;
  z-index: 1;
  background: #fff;
  min-width: 0;
  font-family: ${({ $role }) => $role === "chapter"
    ? '"Microsoft JhengHei UI", "微軟正黑體", "Microsoft JhengHei", "PingFang TC", sans-serif'
    : $role === "focus" ? '"微軟正黑體", "Microsoft JhengHei", "PingFang TC", sans-serif'
      : 'var(--handout-heading-font, "HandoutKai", "標楷體", "DFKai-SB", serif)'};
  font-weight: 700;
  font-size: ${({ $role }) => $role === "chapter" ? "25pt" : $role === "focus" ? "18pt" : "16pt"};
  line-height: 1.2;
  ${({ $role }) => $role === "chapter" && "padding-top: 0.12cm;"}
`;
const Wave = styled.img`
  position: absolute;
  z-index: 0;
  left: 2.65cm;
  top: 50%;
  transform: translateY(-50%);
  max-width: calc(100% - 2.65cm);
  width: 11.5cm;
  height: 0.93cm;
  object-fit: fill;
`;
